"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeLanguage = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var i18n_1 = __importDefault(require("../translations/i18n"));
var changeLanguage = function (language) {
    i18n_1.default.changeLanguage(language || seesignage_utils_1.EnvironmentLanguage.fi);
};
exports.changeLanguage = changeLanguage;
//# sourceMappingURL=language.js.map